import { memo } from "react"
import type { FC } from "react"
import { Button } from "antd"
import classNames from "classnames"
import "./index.scss"
// ==============================================
interface ErrorContentVO {
  resetErrorBoundary?: any
  message: string
  className?: string
}
const ErrorContent: FC<ErrorContentVO> = ({ resetErrorBoundary, message, className = "" }) => {
  return (
    <div className={classNames("error-content", className)}>
      <div className="error-icon" />
      <div className="error-message">{message || "页面出错了"}</div>
      {resetErrorBoundary ? <Button onClick={() => resetErrorBoundary()}>Try again</Button> : null}
    </div>
  )
}

export default memo(ErrorContent)
